import React from 'react'

/**
 * Component to show page header
 * 
 * @component
 * @example
 * return (
 *  <Header />
 * )
 */
const Header = () => {
  return (
    <h2 className="is-size-3 has-text-weight-bold" style={{ marginBottom: 20 }}>
      Expense Tracker
    </h2>
  )
}

export default Header
